import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="overflow-hidden border-t-2 border-[#F5F2EB] bg-[#050505] px-6 pb-10 pt-16 md:px-12 lg:px-20">
    <p className="select-none font-serif font-black uppercase leading-none text-[#F5F2EB]/10 text-[clamp(4rem,18vw,16rem)]">JFLY®</p>
    <div className="mt-10 flex flex-wrap items-center justify-between gap-4 text-[10px] font-mono uppercase tracking-[0.3em] text-[#F5F2EB]/50">
      <span>© MMXXVI JFLY — Pre-loved, one of one</span>
      <div className="flex items-center gap-6">
        <a
          href="https://www.tiktok.com/@jitclips2"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="social-tiktok-link"
          className="transition-colors hover:text-[#FF3B1F]"
        >
          TikTok — @jitclips2
        </a>
        <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors hover:text-[#FF3B1F]">
          Admin
        </Link>
      </div>
    </div>
  </footer>
);
